import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { IBrandConfigsSMS } from "../integrationProvider/integrationProvidersApi";




export interface IEmailConfig {
  id: number
  smtpHost: string
  smtpPort: string
  smtpUsername: string
  smtpPassword: string
  authType: number
  encryptionType: number
  emailName: string
  emailSignature: string
  dateConnected: string
  status: number
}

export interface IEmailInfo {
  id: number
  email: string
  emailSignature: string
  smtpHost: string
  smtpPort: string
  smtpUsername: string
  smtpPassword: string
  authType: number
  encryptionType: number
  categoryCarIds: number[]
  unitIds: number[]
}



export interface IGeneralConfiguration {
  id: number
  brandName: string
  apiKey: string
  secretKey: string
  dateConnected: string
  channelType: number
  zaloAppId: string
  zaloAppSecretKey: string
  zaloOASecretKey: string
  zaloRefreshToken: string
  status: number
  providerId: number
  providerTitle: string
  smtpHost: string
  smtpPort: string
  smtpUsername: string
  smtpPassword: string
  authType: number
  encryptionType: number
}
export interface IProvider {
  id: number
  title: string
  status: number
}


export interface ISmsConfig {
  id: number
  idActive: number
  brandName: string
  phoneNumber: string
  providerName: string
  apiEndpointCSKH: string
  apiEndpointQC: string
  smtpUsername: string
  smtpPassword: string
  categories: string
  units: string
  timestamp: string
  status: number
}

export interface InfoSmsConfig {
  id: number
  providerId: number
  providerName: string
  apiEndpointCSKH: string
  apiEndpointQC: string
  username: string
  password: string
  status: number
  brandConfigs: BrandConfig[]
}

export interface BrandConfig {
  brandName: string
  messageType: string
  phoneNumber: string
  categoryCarIds: number[]
  unitIds: number[]
}

// #region API cho phần tích hợp


export const getListSmsConfig = async (limit?: number, page?: number, search?: string) => {
  const path = "integrationProviders/listSmsConfig"
  const params = {
    limit, page, search
  }
  const result: ResponseSuccessTotal<ISmsConfig[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInfoSmsConfig = async (id: number) => {
  const path = "integrationProviders/infoSmsConfig"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<InfoSmsConfig> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const editSmsConfig = async (
  id: number,
providerId: number, apiEndpointCSKH: string, apiEndpointQC: string, username: string, password: string,
  brandConfigs: IBrandConfigsSMS[]
) => {
  const url = `integrationProviders/editSmsConfig`;
  const params = {
    id, providerId, apiEndpointCSKH, apiEndpointQC, username, password,
    brandConfigs
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

export const updateSMSActiveConfig = async (id: number) => {
  const path = "integrationProviders/activeConfig"

  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}



// #endregion



export const getlistProvider = async () => {
  const path = "integrationProviders/listProvider"
  const params = {}
  const result: ResponseSuccessTotal<IProvider[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getlistMessagingProviderConfig = async (limit?: number, pageNumber?: number, channelType?: number, networkId?: number, search?: string) => {
  const path = "integrationProviders/listMessagingProviderConfig"
  const params = {
    limit, pageNumber, channelType, networkId, search
  }
  const result: ResponseSuccessTotal<IGeneralConfiguration[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const getInfoMessagingProviderConfig = async (
  id: number) => {
  const path = "integrationProviders/infoMessagingProviderConfig"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IGeneralConfiguration> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const addMessagingProviderConfig = async (
  providerId: number,
  channelType: number,
  apiKey?: string,
  secretKey?: string,
  dateConnected?: string,
  brandName?: string,
  zaloAppId?: string,
  zaloAppSecretKey?: string,
  zaloOASecretKey?: string,
  zaloRefreshToken?: String
) => {
  const url = `integrationProviders/addMessagingProviderConfig`;
  const params = {
    providerId, channelType, apiKey, secretKey, dateConnected, brandName, zaloAppId, zaloAppSecretKey, zaloOASecretKey, zaloRefreshToken
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}
export const editMessagingProviderConfig = async (
  id: number,
  providerId: number,
  channelType: number,
  apiKey?: string,
  secretKey?: string,
  dateConnected?: string,
  brandName?: string,
  zaloAppId?: string,
  zaloAppSecretKey?: string,
  zaloOASecretKey?: string,
  zaloRefreshToken?: String
) => {
  const url = `integrationProviders/editMessagingProviderConfig`;
  const params = {
    id, providerId, channelType, apiKey, secretKey, dateConnected, brandName, zaloAppId, zaloAppSecretKey, zaloOASecretKey, zaloRefreshToken
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}
export const updateMessagingProviderConfig = async (id: number) => {
  const path = "integrationProviders/activeMessagingProviderConfig"

  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
// List caau hình email
export const getListEmailConfig = async (
  limit?: number, pageNumber?: number) => {
  const path = "integrationProviders/listEmailConfig"
  const params = {
    pageNumber, limit
  }
  const result: ResponseSuccessTotal<IEmailConfig[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInfoEmailConfig = async (
  id: number) => {
  const path = "integrationProviders/infoEmailConfig"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IEmailInfo> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// theemcaau hình email
export const addMessagingProviderConfigEmail = async (
  email: string,
  categoryCarIds: number[],
  unitIds: number[],
  smtpHost: string,
  smtpPort: string,
  smtpUsername: string,
  smtpPassword: string,
  authType: number,
  encryptionType: number,
  emailSignature: string,

) => {
  const url = `integrationProviders/addMessagingProviderConfigEmail`;
  const params = {
    email,
    categoryCarIds,
    unitIds,
    smtpHost,
    smtpPort,
    smtpUsername,
    smtpPassword,
    authType,
    encryptionType,
    emailSignature
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}
export const editMessagingProviderConfigEmail = async (
  id: number,
  email: string,
  categoryCarIds: number[],
  unitIds: number[],
  smtpHost: string,
  smtpPort: string,
  smtpUsername: string,
  smtpPassword: string,
  authType: number,
  encryptionType: number,
  emailSignature: string,

) => {
  const url = `integrationProviders/editMessagingProviderConfigEmail`;
  const params = {
    id,
    email,
    categoryCarIds,
    unitIds,
    smtpHost,
    smtpPort,
    smtpUsername,
    smtpPassword,
    authType,
    encryptionType,
    emailSignature
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

export const activeEmailConfig = async (
  id: number,

) => {
  const url = `integrationProviders/activeEmailConfig`;
  const params = {
    id,
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}


